import React, { useRef } from 'react';
import Filter from '../Filter';
import ClassicFilter from '../ClassicFilter';

const defaultFilter = {
    id: '',
    name: '',
    identifier: '',
    user_id: '',
    is_shared: false,
    is_readonly: false,
    rules: {
        condition: "and",
        children: []
    } 
}

const FilterBar = ({ 
    title,
    name, 
    identifier,
    module, 
    onInputSearch, 
    onDownloadClick,
    onCreateButtonClick, 
    availableActions = ['search', 'create'],
    onFilterBarUpdate,


    setDefaultFilter,
    changeCondition,
    addNewCondition,
    updateOptionRule,
    updateOptionValue,
    removeCondition,
    saveFilterCondition,
    onClassicFilterChange,
    hideClassicFilter = false,
}) => {
    const  dropdownMenuRef                  = useRef(null);
    const dropdownExportRef                 = useRef(null);

    const onNewFilterClick = async () => {
        if(module?.defaultFilter && module?.defaultFilter?.id && module?.defaultFilter?.id !== '') {
            await setDefaultFilter(defaultFilter)
        }

        if (dropdownMenuRef.current) {
            if(dropdownMenuRef.current.classList.contains('show')) {
                dropdownMenuRef.current.classList.remove('show');
            }
        }
    }

    const onEditFilterClick = () => {
        if (dropdownMenuRef.current) {
            if(dropdownMenuRef.current.classList.contains('show')) {
                dropdownMenuRef.current.classList.remove('show');
            }
        }
    }

    const onClearFilterClick = async() => {
        await setDefaultFilter(defaultFilter)
        await onFilterBarUpdate({ action: 'fetchList', filter: defaultFilter })
    }

    const setActiveCondition = async(filter) => {
        await setDefaultFilter(filter)
        await onFilterBarUpdate({ action: 'fetchList', filter: filter })

        if (dropdownMenuRef.current) {
            if(dropdownMenuRef.current.classList.contains('show')) {
                dropdownMenuRef.current.classList.remove('show');
            }
        }
    }

    const handleFilterChange = async() => {
        await onFilterBarUpdate({ action: 'fetchListClassicFilters' })
    }
    

    const downloadClick = async(type) => {
        if (dropdownExportRef.current) {
            if(dropdownExportRef.current.classList.contains('show')) {
                dropdownExportRef.current.classList.remove('show');
            }
        }

        await onDownloadClick(type)
    }

    const onClassicFilterApply = async() => {
        await onFilterBarUpdate({ action: 'fetchList', filter: module?.classicFilters })
    }

    return (
        <div className="row mb-4">
            <div className="col-12">
                <Filter 
                    filter={module} 
                    settings={module?.settings} 
                    view={name} 
                    identifier={identifier}
                    onFilterChange={async(data) => handleFilterChange(data)}

                    setDefaultFilter={setDefaultFilter}
                    changeCondition={changeCondition}
                    addNewCondition={addNewCondition}
                    updateOptionRule={updateOptionRule}
                    removeCondition={removeCondition}
                    saveFilterCondition={saveFilterCondition}
                    updateOptionValue={updateOptionValue}
                />
            </div>
            <div className="col-xl-12 col-lg-12 col-sm-12">
                <div className="d-flex align-items-center justify-content-sm-end">
                    {
                        (availableActions.some(item => (item === 'export_pdf' || item === 'export_excel'))) ? (
                        <div className="btn-group dropend me-2 mb-2 mb-sm-0">
                            <div className="dropdown dropdown-center">
                                <button disabled={module?.downloading} type="button" className="btn" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                                    <i className="fa fa-download me-1"></i>
                                    { module?.downloading ? 'Fetching...' : 'Print Preview' }
                                </button>
                                <div className="dropdown-menu dropdown-menu-end p-0" ref={dropdownExportRef}>
                                    {
                                        (availableActions.some(item => item === 'export_pdf')) ? (
                                        <a className="dropdown-item" href="#" onClick={(event) => downloadClick('pdf')} >
                                            <i className='fa fa-file-pdf me-2'></i>
                                            PDF
                                        </a>
                                        ) : null
                                    }
                                    {
                                        (availableActions.some(item => item === 'export_excel')) ? (
                                        <a className="dropdown-item" href="#" onClick={(event) => downloadClick('excel')}>
                                            <i className='fa fa-table-cells me-2'></i>
                                            Excel
                                        </a>
                                        ) : null
                                    }
                                </div>
                            </div>
                        </div>
                        ) : null
                    }
                    
                    {
                        (availableActions.some(item => item === 'create')) ? (
                            <div className="me-2">
                                <button 
                                    className="btn btn-primary" 
                                    type="button" 
                                    onClick={onCreateButtonClick}
                                >
                                    <i className="mdi mdi-plus me-1"></i> Create {title}
                                </button>
                            </div>
                        ) : null
                    }
                    
                </div>
            </div>
            <div className="col-xl-12 col-lg-12 col-sm-12">
                {
                    (!hideClassicFilter && module?.classicFilters && Object.keys(module?.classicFilters).length > 0) ? (
                        <ClassicFilter 
                            filters={module?.classicFilters}
                            handleClassicFilterChange={onClassicFilterChange}
                            handleClassicFilterApply={onClassicFilterApply}
                        />
                    ) : null
                }
                {
                    (availableActions.some(item => item === 'search')) ? (
                        <div className="btn-group search-box me-2">
                            <div className="position-relative">
                                <input 
                                    onChange={(event) => onInputSearch(event)} 
                                    value={module?.searchQuery}
                                    placeholder="Search..."
                                    type="text" 
                                    className="form-control bg-light border-light rounded"
                                />
                                <i className="bx bx-search icon-sm search-icon"></i>
                            </div>
                        </div>
                    ) : null
                }
                {
                    (availableActions.some(item => item === 'filter')) ? (
                    <>
                        <div className="btn-group dropend me-2 mb-2 mb-sm-0">
                            <div className="dropdown dropdown-center">
                                <button type="button" className="btn" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                                    {
                                        (module?.defaultFilter && module?.defaultFilter?.id !== '') ? module?.defaultFilter?.name : 'Filters'
                                    }
                                    <i className="fa fa-arrow-up-wide-short ms-2"></i>
                                </button>
                                <div className="dropdown-menu dropdown-menu-end p-0" ref={dropdownMenuRef}>
                                    <div className="card mb-0" style={{width: '22rem'}}>
                                        <div className="card-header p-2">
                                            <div className="row row-cols-auto g-0 text-center">
                                                <div className="col pe-2">
                                                    <div className="p-1" data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg" onClick={async() => await onNewFilterClick()}>
                                                        <p className="mb-0 cursor-pointer">New Filter</p>
                                                    </div>
                                                </div>
                                                {
                                                    (module?.defaultFilter?.id !== '') ? <>
                                                        <div className="col border-start px-2">
                                                            <div className="p-1" data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg" onClick={onEditFilterClick}>
                                                                <p className="mb-0 cursor-pointer">Edit</p>
                                                            </div>
                                                        </div>
                                                        <div className="col border-start px-2">
                                                            <div className="p-1" onClick={onClearFilterClick}>
                                                                <p className="mb-0 cursor-pointer">Clear Filter</p>
                                                            </div>
                                                        </div>
                                                    </> : null
                                                }
                                            </div>
                                            <div className="col-12 mt-2">
                                                <input 
                                                    type="text" 
                                                    className="form-control border-light rounded"
                                                />
                                            </div>
                                        </div>
                                        <div className="card-body p-2">
                                            <h6 className="sub-head p-2">Available Filters</h6>
                                            <ul className="list-unstyled m-0">
                                            {
                                                (module?.settings?.filters && module?.settings?.filters.length > 0) ? module?.settings?.filters.map((filter, index) => {
                                                    return (
                                                        <li key={index} className="cursor-pointer mb-1" onClick={async() => await setActiveCondition(filter)}>
                                                            <div className={`dropdown-item p-2 rounded ${(module?.defaultFilter && module?.defaultFilter?.id !== '' && module?.defaultFilter?.id === filter.id) ? 'active' : ''}`}>
                                                                { (filter.mark_default === true) ? <i className="uil-star me-2"></i> : null }
                                                                {filter.name}
                                                            </div>
                                                        </li>
                                                    )
                                                    }) : <li className="mb-1"><i>No Filters Available</i></li>
                                                }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="btn-group me-2 mb-2 mb-sm-0">
                            {
                            (module?.defaultFilter?.id === '') ? (
                                (module?.defaultFilter?.rules?.children?.length > 0) ? (
                                    <>
                                        <button type="button" className="btn p-0 px-2 border-0" data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg" onClick={onEditFilterClick}>
                                            <i className="fa fa-pen-to-square text-secondary"></i>
                                        </button>
                                        <button type="button" className="btn p-0 px-2 border-0" onClick={onClearFilterClick}>
                                            <i className="fa fa-broom text-secondary fs-5"></i>
                                        </button>
                                    </>
                                ) : (
                                    <button type="button" className="btn p-0 px-2 border-0" data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg" onClick={async() => await onNewFilterClick()}>
                                        <i className="fa fa-square-plus text-secondary fs-4"></i>
                                    </button>
                                )
                            ) : (
                                <>   
                                    <button type="button" className="btn p-0 px-2 border-0" data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg" onClick={onEditFilterClick}>
                                        <i className="fa fa-pen-to-square text-secondary"></i>
                                    </button>
                                    <button type="button" className="btn p-0 px-2 border-0" onClick={onClearFilterClick}>
                                        <i className="fa fa-broom text-secondary fs-5"></i>
                                    </button>
                                </>    
                            )
                            }
                        </div>
                    </>
                    ) : null
                }
            </div>
        </div>
    );
};

export default FilterBar; 